module.exports = __webpack_public_path__ + "static/media/darksteel.1b9a9cf0.jpg";